'use client';
import { BaseImage } from '@/components/baseImage/BaseImage';
import type { BannerProps } from './types';
import { Headline } from '@/components/headline/Headline';
import { Link } from '@/components/link/Link';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import clsx from 'clsx';

export default function AdBanner({
  description,
  link,
  image,
  headline,
  variant,
  sectionId,
}: BannerProps) {
  return (
    <div
      id={sectionId}
      className="px-4 py-12 sm:px-0"
      data-component-id="C028"
      role="banner"
    >
      <div
        className={clsx(
          'container mx-auto w-full overflow-hidden rounded-lg text-white shadow-lg',
          variant === 'dark' ? 'bg-brand-900' : 'bg-brand-500',
        )}
      >
        <div className="grid grid-cols-1 gap-6 p-6 sm:grid-cols-4 sm:gap-8 sm:p-8 lg:grid-cols-12 lg:p-12">
          {/* Image Section */}
          <div className="col-span-1 sm:col-span-4 lg:col-span-6">
            <div className="w-full overflow-hidden rounded-lg">
              <BaseImage
                {...image}
                classNameImage="w-full h-auto object-cover rounded-lg aspect-[5/3] sm:aspect-[3/2]"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
          </div>

          {/* Content Section */}
          <div className="col-span-1 flex flex-col justify-center gap-6 sm:col-span-4 lg:col-span-6">
            <div className="w-full">
              <Headline {...headline}>{headline.title}</Headline>
              {description && (
                <div className="content-dark text-base text-neutral-0 md:text-base">
                  <SerializeDescription description={description} />
                </div>
              )}
            </div>

            {/* Link Section */}
            {link && (
              <Link {...link} className="w-fit">
                {link.title}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
